/**
 * AddPaidPartnerProductsCtrl controller
 */
// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('./img/dragndrop.png')

// controller mixins
AddPaidPartnerProductsCtrl.mixes = [
  'openPopupCtrlMixin'
]

/**
 * AddPaidPartnerProductsCtrl controller
 *
 * @class AddPaidPartnerProductsCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:openPopupCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:AddPaidPartnerProductsCtrl
 */
/* @ngInject */
export default function AddPaidPartnerProductsCtrl ($uibModal, $uibModalInstance, $location, $scope, PartnerProduct, freeProducts,
  networkId, paidProducts) {
  const vm = this
  vm.networkId = networkId
  vm.products = { assigned: { products: [] }, available: { products: [] } }
  vm.products.assigned.products = angular.copy(paidProducts)

  vm.availableFilter = ''
  vm.assignedFilter = ''
  vm.isFormDisabled = true
  /**
   * Table state for pageable request
   *
   * @memberof mwApp/packages.controller:AddPaidPartnerProductsCtrl
   * Ctrl
   */
  vm.initTableState = {
    page: 0,
    count: 25,
    name: '',
    last: false
  }
  vm.tableState = angular.copy(vm.initTableState)

  vm.getProducts = function (tableState) {
    return PartnerProduct.loadPartnerProducts({ networkId }, tableState)
  }

  vm.products.available.products = []

  vm.getInitProducts = function () {
    vm.getProducts(vm.tableState).then((result) => {
      vm.products.available.products.push(...result.content.filter(product =>
        !(vm.products.assigned.products.find(p => p.id === product.id) || freeProducts.find(p => p.id === product.id))))
      vm.tableState.last = result.last
    })
  }

  vm.getInitProducts()

  vm.searchAvailableProducts = function () {
    vm.tableState = angular.copy(vm.initTableState)
    vm.getProducts({ ...vm.tableState, name: vm.availableFilter }).then((result) => {
      vm.products.available.products = result.content || []
      vm.products.available.products = vm.products.available.products.filter(product => {
        return !(vm.products.assigned.products.find(p => p.id === product.id) || freeProducts.find(p => p.id === product.id))
      })
      vm.tableState.last = result.last
    })
  }

  /**
   * Handler for scroll event of Available select list
   *
   * @memberof mwApp/packages.controller:AddPaidPartnerProductsCtrl
   * @param event
   */
  vm.$timerScroll = 0
  vm.contentCallbackAvailableScroll = (event) => {
    const {
      page,
      last
    } = vm.tableState
    if (!last && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerScroll)
      vm.$timerScroll = window.setTimeout(() => {
        vm.getProducts({ ...vm.tableState, page: page + 1 })
          .then((result) => {
            vm.tableState.last = result.last
            vm.products.available.products = vm.products.available.products.concat(result.content)
            vm.products.available.products = vm.products.available.products.filter(product => {
              return !(vm.products.assigned.products.find(p => p.id === product.id) || freeProducts.find(p => p.id === product.id))
            })
            vm.tableState.page++
          })
      }, 700)
    }
  }

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onDrop = function (list, items, index) {
    // eslint-disable-next-line no-undef
    event.stopPropagation()
    list.products = list.products
      .slice(0, index)
      .concat(items)
      .concat(list.products.slice(index))
    items.forEach(item => { item.selected = !item.selected })
    vm.isFormDisabled = false
    return true
  }

  /**
   * dnd-dragging determines what data gets serialized and send to the receiver
   * of the drop. While we usually just send a single object, we send the array
   * of all selected items here.
   */
  vm.getSelected = function (list, link) {
    // eslint-disable-next-line no-undef
    event.stopPropagation()
    link.selected = true
    return list.filter(link => link.selected)
  }
  /**
   * Delete show from showSet
   *
   * @memberof mwApp/packages.controller:AddPaidPartnerProductsCtrl
   */
  vm.deleteProduct = function (channel) {
    event.preventDefault()
    channel.selected = false
    channel.conflicts = []
    vm.products.assigned.products = vm.products.assigned.products.filter(ch => ch.id !== channel.id)
    vm.products.available.products.push(channel)
    vm.isFormDisabled = false
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragstart = function (list, event) {
    list.dragging = true
    if (event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragend = function (list) {
    list.forEach(item => {
      item.selected = false
      item.conflicts = []
    })
    list.dragging = false
  }

  /**
   * Last but not least, we have to remove the previously dragged items in the
   * dnd-moved callback.
   */
  vm.onMoved = function (list) {
    list.products = list.products.filter(item => !item.selected)
  }

  /**
   * Create or edit season, and close modal window afterwards
   *
   * @memberof mwApp/addContentSets.controller:AddPaidPartnerProductsCtrl
   */
  vm.submit = function () {
    $uibModalInstance.close(vm.products.assigned.products)
  }

  /**
   * Method for filtering sets by name
   *
   * @param {Object} product
   * @memberof mwApp/packages.controller:AddPaidPartnerProductsCtrl
   */
  vm.filteredAssigned = (product) => {
    return vm.assignedFilter.length > 0
      ? product.name.includes(vm.assignedFilter)
      : true
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/addContentSets.controller:AddPaidPartnerProductsCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
